import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'generators-categories/test',
    name: 'Generators.Test',
    component: () => import('~/views/TestGeneratorCategoriesLists.vue'),
    meta: {
      title: 'Тестовый генератор'
    }
  }
];

